import React, { useState, useRef, useEffect } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

export default function MusicPlayer() {
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio('/bgm.mp3');
    audio.loop = true;
    audio.volume = 0.15;
    audioRef.current = audio;

    audio.addEventListener('canplaythrough', () => setReady(true));

    // Attempt autoplay
    const tryAutoplay = () => {
      audio.play().then(() => {
        setPlaying(true);
      }).catch(() => {
        // Autoplay blocked by browser — wait for user interaction
        const handleInteraction = () => {
          audio.play().then(() => setPlaying(true)).catch(() => {});
          document.removeEventListener('click', handleInteraction);
          document.removeEventListener('touchstart', handleInteraction);
          document.removeEventListener('scroll', handleInteraction);
        };
        document.addEventListener('click', handleInteraction, { once: true });
        document.addEventListener('touchstart', handleInteraction, { once: true });
        document.addEventListener('scroll', handleInteraction, { once: true });
      });
    };

    // Small delay then try autoplay
    setTimeout(tryAutoplay, 500);

    return () => {
      audio.pause();
      audio.src = '';
    };
  }, []);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
    } else {
      audioRef.current.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  return (
    <button
      onClick={toggle}
      data-testid="music-toggle-btn"
      className={`fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 ${
        playing
          ? 'bg-neonBlue/20 border-2 border-neonBlue/60 text-neonBlue shadow-[0_0_20px_rgba(0,240,255,0.4)] animate-glow-pulse'
          : 'bg-cardBg/90 border-2 border-white/20 text-gray-400 hover:text-white hover:border-neonBlue/40'
      } backdrop-blur-sm`}
      title={playing ? 'Mute Music' : 'Play Music'}
    >
      {playing ? <Volume2 size={20} /> : <VolumeX size={20} />}
      {!playing && ready && (
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-neonBlue rounded-full animate-ping" />
      )}
    </button>
  );
}
